import { Middleware } from "redux";
import { ActionPayload } from "../../../types";
import {
  AddChoicePayload,
  RemoveChoicePayload,
} from "../../actions/choiceActions";
import { RootState } from "../../reducers";
import addChoiceSideEffects from "./addChoice";
import removeChoiceSideEffects from "./removeChoice";

const conditionsMiddleware: Middleware<{}, RootState> =
  ({ getState, dispatch }) =>
  (next) =>
  (action: ActionPayload<any>) => {
    const { type, payload } = action;
    console.log(type);
    console.log(payload);
    if (type === "ADD_CHOICE") {
      addChoiceSideEffects(payload as AddChoicePayload, getState(), dispatch);
    }

    if (type === "REMOVE_CHOICE") {
      removeChoiceSideEffects(
        payload as RemoveChoicePayload,
        getState(),
        dispatch
      );
    }
    next(action);
  };

export default conditionsMiddleware;
